import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/App.css';
import Footer from './layouts/Footer';
import Header from './layouts/Header';
import Navbar from './layouts/Navbar';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Webrouter from './routes/Webrouter';
import { useAuth } from './context/AuthContext';
import { Toaster } from 'react-hot-toast';
import ScrollToTop from './components/ScrollTop/ScrollToTop';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import LocationProvider from './hooks/LocationProvider';
import { LocationContext } from './context/LocationContext';

function BuyerApp() {
  const [userLocation, setUserLocation] = useState(null);
  const [userAddress, setUserAddress] = useState(null);

  useEffect(() => {
    const checkTokenExpiration = () => {
      const expirationTime = Cookies.get('jwtExpiration');
      if (expirationTime) {
        const timeLeft = expirationTime - Date.now();
        if (timeLeft > 0) {
          setTimeout(() => {
            console.log("JWT expired, reloading...");
            Cookies.remove('token', { path: '/', sameSite: 'Lax' });
            Cookies.remove('roles', { path: '/', sameSite: 'strict' });
            Cookies.remove('jwtExpiration', { path: '/' });
            window.location.reload();
          }, timeLeft);
        }
      }
    };
    checkTokenExpiration();
  }, []);

  const handleLocationReady = (coords, address) => {
    setUserLocation(coords);
    setUserAddress(address);
    console.log('User coords:', coords);
    console.log('User address:', address);
  };

  return (
    <LocationContext.Provider
      value={{
        coords: userLocation,
        address: userAddress,
        setCoords: setUserLocation,
        setAddress: setUserAddress,
      }}
    >
      <LocationProvider onLocationReady={handleLocationReady} />
      <Router>
        <ScrollHandler />
        <AuthenticatedApp />
      </Router>
    </LocationContext.Provider>
  );
}

function AuthenticatedApp() {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const hideHeaderNavbar = location.pathname.startsWith('/forgot-password');

  return (
    <>
      {!hideHeaderNavbar && <Header isAuthenticated={isAuthenticated} />}
      <ScrollToTop />
      {!hideHeaderNavbar && <Navbar isAuthenticated={isAuthenticated} />}
      <Webrouter isAuthenticated={isAuthenticated} />
      {!hideHeaderNavbar && <Footer />}
      <Toaster position='top-right' reverseOrder={false} />
    </>
  );
}

function ScrollHandler() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          const yOffset = -80;
          const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 200);
    }
  }, [location]);
  return null;
}

export default BuyerApp; 